'use es6';

import { createSelector } from 'reselect';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import { FilterOptionTypes } from 'ui-asset-management-lib/components/tableFilters/Constants';
const getViewFilters = state => state.viewFilters;
export const getIsCustomTeamOptionDisabled = createSelector([getViewFilters], viewFilters => {
  const filter = viewFilters.get(DefaultFilterNames.CREATED_BY_MY_TEAM) || viewFilters.get(DefaultFilterNames.OWNED_BY_MY_TEAM);
  return filter.isDisabled();
});
const viewToOption = view => ({
  text: view.getTitle(),
  value: view.id,
  type: FilterOptionTypes.CUSTOM,
  disabled: view.isDisabled()
});
export const getAdditionalOptions = createSelector([getViewFilters], viewFilters => viewFilters.filter((__view, key) => !Object.values(DefaultFilterNames).includes(key)).map(viewToOption).valueSeq().toArray());